(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsElasticPropertiesController', TabObjectsElasticPropertiesController);

    TabObjectsElasticPropertiesController.$inject = ['$state', '$stateParams', 'entity', 'properties', '$uibModal', 'editableOptions', 'TabObjectProperties', 'AlertService'];

    function TabObjectsElasticPropertiesController($state, $stateParams, entity, properties, $uibModal, editableOptions, TabObjectProperties, AlertService) {
        var vm = this;
        var editedProperty = {};
        vm.saveReference = saveReference;
        vm.checkValueBeforeSave = checkValueBeforeSave;
        vm.checkBeforeExit = checkBeforeExit;
        vm.checkNoPendingEdit = checkNoPendingEdit;
        vm.reloadState = reloadState;
        vm.save = save;
        vm.searchText = "";
        vm.properties = [];
        vm.app = [];
        vm.tabObject = entity;
        // vm.properties = properties;

        if(properties.$promise) {
            properties.$promise.then(function () {
                vm.properties = properties;
                vm.app = angular.copy(vm.properties);
            });
        }

        function saveReference(key, value) {
            save(key, value);
        }

        function checkValueBeforeSave(data) {
            return data ? true : "Value cannot be empty";
        }


        function checkBeforeExit() {
            if (checkNoPendingEdit()) {
                window.history.back();
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objects-properties-dialog.html'
                }).result.then(function () {
                    window.history.back();
                }, function () {
                    //null
                });
            }
        }

        function reloadState() {
            $state.transitionTo($state.current, $stateParams, {
                reload: true
            });
        }

        function checkNoPendingEdit() {
            return angular.equals({}, editedProperty);
        }

        function save(key, value) {
                TabObjectProperties.elasticUpdate({
                    key: key,
                    value: value,
                    objectUniqueCode: vm.tabObject.objectUniqueCode
                }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            AlertService.success("Property updated")
        }

        function onSaveError() {
            reloadState();
            AlertService.error("Error update property")

        }

        vm.search = function () {
            vm.app = angular.copy(vm.properties);
            angular.forEach(vm.app, function (value, key) {
                if(!key.toString().includes(vm.searchText)){
                    delete vm.app[key];
                }
            });
        };
    }
})();
